import { c as _c } from "react/compiler-runtime";
import { type VariantProps, cva } from "class-variance-authority";
import { type ComponentType, type SVGProps } from "react";
import { cn } from "@/cn";
export const iconVariants = cva("size-4 shrink-0", {
  variants: {
    size: {
      default: "size-4",
      sm: "size-3.5",
      xs: "size-3",
      lg: "size-5"
    },
    weight: {
      default: "stroke-[1.5]",
      thin: "stroke-1",
      bold: "stroke-2"
    }
  },
  defaultVariants: {
    size: "default",
    weight: "default"
  }
});
export type IconVariants = VariantProps<typeof iconVariants>;
export type StyledIconProps = Omit<SVGProps<SVGSVGElement>, "size" | "stroke"> & IconVariants;
export type StyledIcon = ComponentType<StyledIconProps>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function styled(Icon: ComponentType<any>): StyledIcon {
  function StyledIcon(t0) {
    const $ = _c(12);
    let className;
    let props;
    let size;
    let weight;
    if ($[0] !== t0) {
      ({
        className,
        size,
        weight,
        ...props
      } = t0);
      $[0] = t0;
      $[1] = className;
      $[2] = props;
      $[3] = size;
      $[4] = weight;
    } else {
      className = $[1];
      props = $[2];
      size = $[3];
      weight = $[4];
    }
    let t1;
    if ($[5] !== className || $[6] !== size || $[7] !== weight) {
      t1 = cn(iconVariants({
        size,
        weight
      }), className);
      $[5] = className;
      $[6] = size;
      $[7] = weight;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    let t2;
    if ($[9] !== props || $[10] !== t1) {
      t2 = <Icon aria-hidden="true" {...props} className={t1} />;
      $[9] = props;
      $[10] = t1;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    return t2;
  }
  StyledIcon.displayName = Icon.displayName ?? Icon.name;
  return StyledIcon;
}